export default {"src":"/_next/static/media/NFTAirdropDark.7e636a41.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};